import { CommonModule } from '@angular/common';

import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { Router, RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';

import { SelectModule } from 'primeng/select';

import { InputTextModule } from 'primeng/inputtext';

import { ToastModule } from 'primeng/toast';

import { ToolbarModule } from 'primeng/toolbar';

import { MessageService } from 'primeng/api';

import { finalize } from 'rxjs';

import { StaffDisputeService, StaffDisputeSummary } from '../services/staff-dispute.service';

import { InMemoryStorageService } from '../services/in-memory-storage.service';

import { LoaderService } from '../services/loader.service';

import {
    computeDisputeKpis,
    defaultDisputeDateRange,
    DisputeFilter,
    DisputeKpiStats,
    matchesDisputeDateRange,
    matchesDisputeFilter,
    matchesDisputeSearch
} from './dispute.utils';

import { DisputeKpiBarComponent } from './components/dispute-kpi-bar.component';

import { DisputeClaimsTableComponent } from './components/dispute-claims-table.component';



@Component({

    selector: 'app-dispute-review',

    standalone: true,

    encapsulation: ViewEncapsulation.None,

    imports: [

        CommonModule,

        FormsModule,

        RouterModule,

        ButtonModule,

        SelectModule,

        InputTextModule,

        ToastModule,

        ToolbarModule,

        DisputeKpiBarComponent,

        DisputeClaimsTableComponent

    ],

    providers: [MessageService],

    templateUrl: './dispute-review.component.html',

    styleUrl: './dispute-review.component.scss'

})

export class DisputeReviewComponent implements OnInit {

    allDisputes: StaffDisputeSummary[] = [];

    filteredDisputes: StaffDisputeSummary[] = [];

    kpiStats: DisputeKpiStats = {
        total: 0,
        submitted: 0,
        underReview: 0,
        approved: 0,
        rejected: 0
    };



    searchQuery = '';

    selectedStatus: DisputeFilter = 'ALL';

    fromDate = '';

    toDate = '';

    readonly statusOptions = [

        { label: 'All', value: 'ALL' as const },

        { label: 'Submitted', value: 'SUBMITTED' as const },

        { label: 'Under review', value: 'UNDER_REVIEW' as const },

        { label: 'Accepted', value: 'APPROVED' as const },

        { label: 'Rejected', value: 'REJECTED' as const }

    ];



    private scope = {
        companyId: '',
        divisionId: '',
        whsId: ''
    };



    constructor(

        private readonly disputeService: StaffDisputeService,

        private readonly inMemoryStorage: InMemoryStorageService,

        private readonly messageService: MessageService,

        private readonly loaderService: LoaderService,

        private readonly router: Router

    ) {}



    ngOnInit(): void {

        this.scope = {

            companyId: this.inMemoryStorage.get('company') || '',

            divisionId: this.inMemoryStorage.get('division') || '',

            whsId:

                this.inMemoryStorage.get('warehouseId') ||

                this.inMemoryStorage.get('whsId') ||

                this.inMemoryStorage.get('warehouse') ||

                ''

        };

        this.reload();

    }



    reload(): void {

        if (!this.scope.companyId || !this.scope.divisionId || !this.scope.whsId) {

            this.messageService.add({

                severity: 'warn',

                summary: 'Missing scope',

                detail: 'Company, division and warehouse must be selected before reviewing disputes.'

            });

            this.allDisputes = [];

            this.applyFilters();

            return;

        }



        this.loaderService.show('Loading disputes...', 'Please wait...');

        this.disputeService

            .listClaims(this.scope, 'ALL')

            .pipe(finalize(() => this.loaderService.hide()))

            .subscribe({

                next: (rows) => {
                    this.allDisputes = rows || [];
                    this.applyFilters();
                },

                error: (err) => {

                    this.messageService.add({

                        severity: 'error',

                        summary: 'Failed to load disputes',

                        detail: err?.error?.message || err?.error || 'Please retry.'

                    });

                }

            });

    }



    onSearchChange(): void {

        this.applyFilters();

    }



    onFilterChange(): void {
        this.applyFilters();
    }

    onKpiFilterSelect(filter: DisputeFilter): void {
        this.selectedStatus = filter;
        this.applyFilters();
    }

    onDateChange(): void {
        if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
            this.toDate = this.fromDate;
        }
        this.applyFilters();
    }

    applyFilters(): void {
        const byDate = this.allDisputes.filter((row) =>
            matchesDisputeDateRange(row, this.fromDate, this.toDate)
        );
        this.kpiStats = computeDisputeKpis(byDate);
        this.filteredDisputes = byDate
            .filter((row) => matchesDisputeFilter(row.status, this.selectedStatus))
            .filter((row) => matchesDisputeSearch(row, this.searchQuery));
    }



    openClaim(claimNumber: string): void {

        this.router.navigate(['/dispute-review', claimNumber]);

    }

}


